import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { View } from 'src/app/components/base.component';
import { AuthService } from 'src/app/services/auth.service';
import { UIStateService } from 'src/app/services/ui-state.service';
import { UserService } from 'src/app/services/user.service';
import { ChatbarService } from 'src/app/services/chatbar.service';
import { ToastNotification, SignalService, MessageToast, AnnouncementNotification, FriendshipToast, AchievementToast } from 'src/app/services/signal.service';
import { InboxService } from 'src/app/services/inbox.service';


@Component({
    selector: 'app-toast-host',
    templateUrl: './toast-host.component.html',
    styleUrls: ['./toast-host.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastHostComponent extends View {

    public toasts: Observable<ToastNotification[]>;
    // Written from handleToasts(), driven by SignalService.toasts.subscribe() below - an
    // external service subject, not a template-bound handler - so this needs to be a signal for
    // OnPush to see the update.
    protected visibleToasts = signal<ToastNotification[]>([]);

    constructor(private notificationService: SignalService, private chatService: ChatbarService, private inboxService: InboxService, authService: AuthService, uiStateService: UIStateService) {
        super(authService, uiStateService);
        this.subscriptions.push(notificationService.toasts.subscribe(this.handleToasts.bind(this)));
    }

    private handleToasts(tsts: ToastNotification[]): void {
        // Keeps every currently-visible toast still present in tsts (in its existing order), then
        // appends whatever's newly arrived in tsts (in tsts's own order) - the same net effect as
        // the original push-then-splice-by-index approach, expressed as one pure recomputation so
        // the signal only needs a single .set() per update.
        this.visibleToasts.update(current =>
            [...current.filter(t => tsts.includes(t)), ...tsts.filter(t => !current.includes(t))]);
    }

    public viewChannel(toast: MessageToast) {
        this.chatService.OpenChannel(toast.channel);
        toast.onClose();
    }

    public getToastType(toast: ToastNotification) {
        return toast.constructor.name;
    }

    acceptFriend(friendUsername: string, toast: FriendshipToast) {
        this.subscriptions.push(this.inboxService.addFriend(friendUsername).subscribe());
        toast.onClose();
    }

    removeFriend(friendUsername: string, toast: FriendshipToast) {
        this.subscriptions.push(this.inboxService.removeFriend(friendUsername).subscribe());
        toast.onClose();
    }

    public messageToastName: string = MessageToast.name;
    public friendshipToastName: string = FriendshipToast.name;
    public achievementToastName: string = AchievementToast.name;

}
